<template>
  <div class="main-container">
    <div class="only-print">
      <Icon
        :model="
          appStore.currentMode() === DisplayMode.Light
            ? appStore.configuration?.components.logotype.light
            : appStore.configuration?.components.logotype.dark
        "
        :alt="t('logotype.alt')"
        :key="componentKey"
        class="logotype print-logo"
      />
      <Introduction class="print-introduction" :key="componentKey"></Introduction>
    </div>
    <div v-if="!chatStore.isFirstQuestionSent">
      <Icon
        :model="
          appStore.currentMode() === DisplayMode.Light
            ? appStore.configuration?.components.logotype.light
            : appStore.configuration?.components.logotype.dark
        "
        :alt="t('logotype.alt')"
        :key="componentKey"
        class="logotype"
      />
      <Introduction :key="componentKey"></Introduction>
    </div>

    <div
      class="product-select-row"
      v-if="
        appStore.configuration?.components.productSelect.visible &&
        !appStore.configuration.components.productFromUrl.enabled
      "
    >
      <label class="product-label">{{ $t('productSelect.label') }}</label>
      <ProductSelector />
    </div>

    <div
      class="product-select-row"
      v-if="appStore.configuration?.components.productFromUrl.enabled && appStore.productFromUrl"
    >
      {{ $t('productFromUrl.label') }} {{ appStore.productFromUrl }}
    </div>

    <Chat
      :model="appStore.configuration?.components?.chat"
      :key="componentKey"
      :footer="appStore.configuration?.components?.footer"
      @open-feedback-modal="handleOpenFeedbackModal($event)"
      @copy-agent-response="handleEmit('copy')"
    />
  </div>
</template>

<script setup lang="ts">
import { t } from '../composables/Translation'
import { ref } from 'vue'
import { useAppStore } from '../stores/appStore'
import Icon from './Icon.vue'
import Chat from './chat/Chat.vue'
import Introduction from './Introduction.vue'
import { useChatStore } from '../stores/chatStore'
import ProductSelector from '../components/ProductSelector.vue'
import type { FeedbackGrade } from '../types/FeedbackGrade'
import { DisplayMode } from '../types/app/displayMode'

const appStore = useAppStore()
const chatStore = useChatStore()
const componentKey = ref(0)

const emit = defineEmits<{
  (e: 'copy-agent-response'): void
  (e: 'open-feedback-modal', grade: FeedbackGrade): void
}>()

function handleEmit(emitSignal: string) {
  if (emitSignal === 'copy') {
    emit('copy-agent-response')
  }
}

function handleOpenFeedbackModal(grade: FeedbackGrade) {
  emit('open-feedback-modal', grade)
}
</script>

<style scoped lang="scss">
.product-select-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 16px;
  line-height: normal;
  color: var(--text-color);
}

.product-label {
  padding-right: 10px;
  font-weight: 500;
  align-items: center;
}

:deep(.product-selector),
:deep(.product-selector-control),
:deep(.vue-select) {
  display: inline-flex !important;
  align-items: center !important;
  vertical-align: middle !important;
  margin: 0 !important;
  padding: 0 !important;
}

:deep(.vue-select .menu) {
  display: block !important;
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
  min-width: 155px !important;
  width: max-content !important;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: var(--background-color);
  margin-top: 4px; /* small spacing below control */
  z-index: 10;
}

.main-container {
  display: flex;
  width: 768px;
  flex-direction: column;
  align-items: flex-start;
  margin: auto;
}

@media (max-width: 992px) {
  .main-container {
    width: auto;
    padding-left: 12px;
    padding-right: 12px;
  }
}

.logotype {
  width: 200px;
  margin: auto;
  margin-top: 32px;
  margin-bottom: 32px;
}
</style>
